import { useEffect, useState } from 'react';

import {
    fetchPermissionsV2,
    permissionsQueryClient,
} from '../../../../services/permissions/permissionsV2.service';
import { PermissionSetDtoV2 } from '../../../../services/permissions/permissionsV2.types';

export type PermissionState = 'loading' | 'permitted' | 'denied';

export const useHasPermissionV2 = (permissionName: string): PermissionState => {
    const customerId = sessionStorage.getItem('cop:customer-id') ?? '';

    const [state, setState] = useState<PermissionState>(() => {
        // Synchronously read from pre-warmed cache (filled by permissionsPrewarm.ts on page load).
        // Cache warm  → resolve to 'permitted' or 'denied' immediately — no re-render, no flicker.
        // Cache cold  → 'loading' — PermissionAccessGuard renders null quietly until resolved.
        const cached = permissionsQueryClient.getQueryData<PermissionSetDtoV2>(['PermissionsV2', customerId]);
        if (cached) {
            return cached.permissions.some(p => p.name === permissionName) ? 'permitted' : 'denied';
        }
        return 'loading';
    });

    useEffect(() => {
        if (!customerId) { setState('denied'); return; }
        fetchPermissionsV2(customerId)
            .then(data =>
                setState(data.permissions.some(p => p.name === permissionName) ? 'permitted' : 'denied')
            )
            .catch(() => setState('denied'));
    }, [customerId, permissionName]);

    return state;
};